import {BusinessPermissionFlowEnum, OperationStateTypesEnum} from 'presentation/constants';
import {usePersonalData} from 'presentation/hooks';
import {usePostB2BBeneficiaryAuthorizationMutation} from 'presentation/mutation/usePostB2BBeneficiaryAuthorizationMutation';
import {useGetB2BBeneficiaryStatusQuery} from 'presentation/queries/useGetB2BBeneficiaryStatusQuery';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

export const useBusinessToggle = () => {
	const {
		accountData: {beneficiary},
		isB2BBeneficiaryAuthorized,
	} = usePersonalData();
	const {refetch: resetIsB2BBeneficiaryAuthorized} = useGetB2BBeneficiaryStatusQuery({
		userCode: beneficiary.cdUsuarioC,
	});
	const [warningDisabledAccessState, setWarningDisabledAccessState] = useState(false);

	const [operationScheduleState, setOperationScheduleState] = useState<OperationStateTypesEnum>(
		OperationStateTypesEnum.NONE,
	);

	const navigate = useNavigate();

	const AUTHORIZE_ACCESS_IS_LOADING =
		operationScheduleState === OperationStateTypesEnum.SUBMITTING;
	const AUTHORIZE_ACCESS_IS_ERROR = operationScheduleState === OperationStateTypesEnum.ERROR;
	const AUTHORIZE_ACCESS_IS_DONE = operationScheduleState === OperationStateTypesEnum.DONE;

	const goToAccessPermissionPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			navigate(BusinessPermissionFlowEnum.ACCESS_PERMISSION);
			return;
		}

		setWarningDisabledAccessState(true);
	};

	const {mutateAsync: postB2BBeneficiaryAuthorization} =
		usePostB2BBeneficiaryAuthorizationMutation();

	const handleAuthorizeAccess = async () => {
		try {
			setOperationScheduleState(OperationStateTypesEnum.SUBMITTING);

			await postB2BBeneficiaryAuthorization({
				userCode: beneficiary.cdUsuarioC,
				enable: !isB2BBeneficiaryAuthorized,
			});

			resetIsB2BBeneficiaryAuthorized();
			setWarningDisabledAccessState(false);
			setOperationScheduleState(OperationStateTypesEnum.DONE);
		} catch (error) {
			setOperationScheduleState(OperationStateTypesEnum.ERROR);
		}
	};

	const retryAuthorizeAccess = () => {
		setWarningDisabledAccessState(true);
		handleAuthorizeAccess();
	};

	return {
		businessHasAccessState: isB2BBeneficiaryAuthorized,
		AUTHORIZE_ACCESS_IS_LOADING,
		AUTHORIZE_ACCESS_IS_ERROR,
		AUTHORIZE_ACCESS_IS_DONE,
		handleAuthorizeAccess,
		setOperationScheduleState,
		goToAccessPermissionPage,
		warningDisabledAccessState,
		setWarningDisabledAccessState,
		retryAuthorizeAccess,
	};
};
